import { cn } from '../lib/utils';
import { useCurrencyStore } from '../stores/currency';

interface CurrencyTextProps extends React.HTMLAttributes<HTMLSpanElement> {
	/** The numeric amount to format */
	amount: number | null | undefined;
	/** Override currency instead of using the global store */
	currency?: string;
	/** A per-piece price: up to 4 decimals when the figure needs them. */
	unit?: boolean;
}

export function CurrencyText({ amount, currency, unit, className, ...props }: CurrencyTextProps) {
	const { selectedCurrency } = useCurrencyStore();
	const code = currency || selectedCurrency;

	if (amount == null) {
		return (
			<span className={className} {...props}>
				—
			</span>
		);
	}

	const formatted = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: code,
		// Totals always at 2 decimals — never "DKK 12.5".
		minimumFractionDigits: 2,
		maximumFractionDigits: unit ? 4 : 2,
	}).format(amount);

	return (
		<span className={cn('font-mono', className)} {...props}>
			{formatted}
		</span>
	);
}
